import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface BadgeProps {
  text?: string;
  tooltip?: string;
}

export const Badge = ({ text, tooltip }: BadgeProps) => (
  <TippyV2 role="tooltip" content={tooltip} className="cursor-pointer">
    <div className="bg-primary border-primary rounded-md border px-2 py-px">
      <Typography.LabelXs weight="medium" color="text-secondary">
        {text}
      </Typography.LabelXs>
    </div>
  </TippyV2>
);
